import { filterRecommendationProducts } from 'lib/utils/recommendation-eligibility'
import { getRecommendation } from 'components/shared/useEffect/usePersonalizedRecommendation/utils'
import { trackProductListViewedWithRef } from 'pages/similar/utils'

const JUST_FOR_YOU_PRODUCTS_LIMIT = 18

export const fetchJustForYouProducts = async ({
  auth,
  productId,
  pageNo,
  refId,
  refType,
  skipProduct,
  onSuccess,
  onError,
}) => {
  const recommendation = await getRecommendation(auth, productId, false, {
    skip: skipProduct,
    limit: JUST_FOR_YOU_PRODUCTS_LIMIT,
  })

  if (recommendation?.products) {
    const justForYouIdLists = filterRecommendationProducts(
      recommendation.products,
    ).map((item) => +item.id_product)

    onSuccess(recommendation?.products)
    trackProductListViewedWithRef(
      productId,
      justForYouIdLists,
      pageNo + 1,
      refType,
      refId,
    )
  } else {
    onError({ error: true })
  }
}

export default { fetchJustForYouProducts }
